module.exports = __webpack_public_path__ + "img/arrow-down.06a147c3.svg";